import { Clasificacion } from './../../../models/clasificacion.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-clasificacion-modificar',
  templateUrl: './clasificacion-modificar.component.html',
  styleUrls: ['./clasificacion-modificar.component.css'],
  providers: [FormService]
})
export class ClasificacionModificarComponent {
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rows = [];
  public actualRow;
  public clasificacionModificar: Clasificacion;
  public formulario;
  public temp_clasif;
  public matcher = new FormService();

  constructor(private dialog: MatDialog) {

    this.formulario = new FormGroup({
      clasificacion: new FormControl(''),
      metro: new FormControl(0, [Validators.pattern(/^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/)]),
    })
    if (!JSON.parse(localStorage.getItem("clasificacionModificar"))) {
      localStorage.setItem("clasificacionModificar", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("clasificacionModificar"));

    }
    this.clasificacionModificar = { clasificacion: "", metro: 0 };
    this.temp_clasif = { clasificacion: "", metro: 0 };
  }

  add_clasificacion() {


    this.actualRow = localStorage.getItem("clasificacionModificar");
    this.rows = JSON.parse(this.actualRow);

    if (!this.formulario.value.clasificacion && !this.formulario.value.metro) {
      console.log("no se ingresaron datos");
      this.dialog.open(this.openModalNODATA);

    } else {
      this.rows = this.rows.concat({
        clasificacion: this.formulario.value.clasificacion,
        metro: this.formulario.value.metro

      })
      localStorage.setItem("clasificacionModificar", JSON.stringify(this.rows));
      this.formulario.reset();
    }




  }

  get_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.temp_clasif.id = id;
        this.temp_clasif.clasificacion = this.rows[x].clasificacion;
        this.temp_clasif.metro = this.rows[x].metro;

        this.dialog.open(this.openModal);
      }
    }
  }

  cleanData() {
    this.temp_clasif = { clasificacion: "", metro: 0 };
  }

  saveclasificacion() {
    var id = this.temp_clasif.id;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("clasificacionModificar", JSON.stringify(this.rows));

        $("#clasif_modal").modal("hide");
        this.actualRow = localStorage.getItem("clasificacionModificar");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
          clasificacion: this.temp_clasif.clasificacion,
          metro: this.temp_clasif.metro
        })
        localStorage.setItem("clasificacionModificar", JSON.stringify(this.rows));
        this.temp_clasif = { clasificacion: "", metro: 0 };
        this.dialog.closeAll();
      }
    }
  }

  delete_clasificacion(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("clasificacionModificar", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("clasificacionModificar");
    this.rows = JSON.parse(this.actualRow);
  }

}
